import { IClientConfig } from "src/client-config/config";
import { ISelection } from "src/constants/interfaces/bet";
import { TranslateFunc } from "src/constants/types";
import { ISwarmEventResponse, ISwarmGameResponse } from "../swarm/models/response";

type GamePrimitives = {
  [key in keyof ISwarmGameResponse]: ISwarmGameResponse[key] extends string | number ? key : never;
}[keyof ISwarmGameResponse]

export const eventNameReplacements: Record<string, GamePrimitives> = {
  'P1': 'team1_name',
  'P2': 'team2_name',
};

export const getEventName = (
  t: TranslateFunc,
  config: IClientConfig,
  event: ISwarmEventResponse,
  game: ISwarmGameResponse,
) => {
  if (!config.enableEventSideNameReplacement) return t(event.name);

  const replaceKey = eventNameReplacements[event.type];

  return replaceKey ? game[replaceKey] : event.name;
}